// extracted by mini-css-extract-plugin
export var footerImage = "footer-image-module--footerImage--HkrwY util-module--fullWidth--iiqEb";
export var mqMaxMd = "screen and (max-width: 48em)";